import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'
import Field from 'components/controls/field'
import 'less/edit-sample-size-modal.less'
import { TagInput, Intent } from "@blueprintjs/core";
import { axiosInstance } from 'network/apis'
import { Spinner } from '@blueprintjs/core'

const AddModeratorsModal = props => {
    const [selectedModerators, setSelectedModerators] = useState([])
    const [selectedModeratorsId, setSelectedModeratorsId] = useState([])
    const [chipValues, setChipValues] = useState([])
    const [filter, setFilter] = useState("")
    const [filteredModerators, setFilteredModerators] = useState([])
    const [displayedModerators, setDisplayedModerators] = useState([])
    const [noModeratorsMsg, setNoModeratorsMsg] = useState('')
    const [defaultModerators, setDefaultModerators] = useState([])
    const [defaultModeratorsDetails,setDefaultModeratorsDetails] = useState([])
    const [displayClarificationMessage, setDisplayClarificationMessage] = useState(false)

    useEffect(() => {
        if (props.moderatorList.length === 0 && !props.noModerators) {
            props.fetchModerators({ clientId: props.clientId })
        } else if (props.noModerators) {
            setNoModeratorsMsg(props.t('no.moderators.message'))
        }

    }, [])

    useEffect(() => {
        if (props.noModerators) {
            setNoModeratorsMsg(props.t('no.moderators.message'))
        }
    }, [props.noModerators])

    useEffect(() => {
        async function getModeratorsForProject(projectId) {
            const moderatorsForProjectResp = await axiosInstance.get(`/user/get_all_moderators/${projectId}`, { handlerEnabled: true })
            console.log("moderatorsForProjectResp ", moderatorsForProjectResp)
            setSelectedModerators(moderatorsForProjectResp.data.moderatorInfo)
            setSelectedModeratorsId(moderatorsForProjectResp.data.moderatorInfo.map(mod => mod.id))
            setChipValues(moderatorsForProjectResp.data.moderatorInfo.map(mod => <div key={mod.id}>{`${mod.firstName} ${mod.lastName}`}</div>))
            setDefaultModerators(moderatorsForProjectResp.data.moderatorInfo.map(mod => mod.id))
            setDefaultModeratorsDetails(moderatorsForProjectResp.data.moderatorInfo)
        }
        if (!props.modifiedModerators ) getModeratorsForProject(props.projectId)
    }, [])

    const handleAddOrRemove = (moderator) => {
        if (selectedModeratorsId.includes(moderator.id)) {
            // remove the moderator from the list
            setSelectedModerators(selectedModerators.filter(mod => mod.id !== moderator.id))
            setSelectedModeratorsId(selectedModeratorsId.filter(mod => mod !== moderator.id))
            setChipValues(chipValues.filter(chip => chip.key != moderator.id))
        } else {
            // add the moderator to the list
            const newModerator =  {...moderator, interviewCount:0}
            setSelectedModerators([...selectedModerators, newModerator])
            setSelectedModeratorsId([...selectedModeratorsId, moderator.id])
            setChipValues([...chipValues, <div key={moderator.id}>{`${moderator.firstName} ${moderator.lastName}`}</div>])
        }
    }

    const onChipRemove = (moderator) => {
        setSelectedModerators(selectedModerators.filter(mod => mod.id != moderator.key))
        setSelectedModeratorsId(selectedModeratorsId.filter(mod => mod != moderator.key))
        setChipValues(chipValues.filter(chip => chip.key != moderator.key))
    }

    const getTagProps = (_v, index) => ({
        intent: Intent.NONE,
        interactive: true,
        minimal: false,
        large: false
    })

    const filterModerators = (q, moderators = props.moderatorList) => {
        if (q) {
            return moderators.filter(i => {
                const re = new RegExp(q, 'i')
                return re.test(`${i.firstName} ${i.lastName}`)
            })
        }
        return []
    }

    const updateAndFilter = (q = "") => {
        setFilteredModerators(filterModerators(q, props.moderatorList))
    }

    useEffect(() => {
        if (filter !== "") {
            setDisplayedModerators(filteredModerators)
        } else {
            setDisplayedModerators(props.moderatorList)
        }
    }, [filteredModerators, filter, props.moderatorList])

    useEffect(() => {
        updateAndFilter(filter)
    }, [filter])

    const selectionDidNotChange = () => {
            return (selectedModeratorsId.length == defaultModerators.length) && selectedModeratorsId.every(element => defaultModerators.indexOf(element) > -1)
            && defaultModerators.every(element => selectedModeratorsId.indexOf(element) > -1)
    }

    useEffect(() => {
        const selectedModeratorsIdOnGoBack = []
        const chipValuesOnGoBack = []
        const selectedModeratorsOnGoBack = []
        const defaultModeratorsIds = []
     

        props.modifiedModerators && props.modifiedModerators.forEach(item => {
            selectedModeratorsOnGoBack.push(item)
            defaultModeratorsIds.push(item.id)
        })

        if (props.status === 412 && props.messageKey === "noAvailabilities" && props.moderatorsScheduledInterviews && props.moderatorsScheduledInterviews.length === 0) {
            props.defaultModeratorsDetails && props.defaultModeratorsDetails.forEach(item => {
                if (!defaultModeratorsIds.includes(item.id)) selectedModeratorsOnGoBack.push(item)
            }
            )
            if (props.modifiedModerators) {
                for (const key in selectedModeratorsOnGoBack) {
                    selectedModeratorsIdOnGoBack.push(parseInt(selectedModeratorsOnGoBack[key].id))
                    chipValuesOnGoBack.push(<div key={selectedModeratorsOnGoBack[key].id}>{`${selectedModeratorsOnGoBack[key].firstName} ${selectedModeratorsOnGoBack[key].lastName}`}</div>)
                }
            }
            setDefaultModeratorsDetails(props.defaultModeratorsDetails)
        }
        else {
            if (props.modifiedModerators) {
                Object.entries(props.modifiedModerators).map(item => {
                    selectedModeratorsIdOnGoBack.push(parseInt(item[1].id))
                    chipValuesOnGoBack.push(<div key={item[1].id}>{`${item[1].firstName} ${item[1].lastName}`}</div>)
                })
            }

            if (props.moderatorsScheduledInterviews) {
                Object.entries(props.moderatorsScheduledInterviews).map(item => {
                    if (!selectedModeratorsIdOnGoBack.includes(item[1][0].moderatorId)) {
                        selectedModeratorsIdOnGoBack.push(parseInt(item[1][0].moderatorId))
                        chipValuesOnGoBack.push(<div key={item[1][0].moderatorId}>{`${item[1][0].firstName} ${item[1][0].lastName}`}</div>)
                        selectedModeratorsOnGoBack.push({ "firstName": item[1][0].firstName, "lastName": item[1][0].lastName, "id": parseInt(item[1][0].moderatorId), "interviewCount": item[1].length })
                    }
                }
                )
                setDefaultModeratorsDetails(selectedModeratorsOnGoBack)
            }
        }

        setSelectedModeratorsId(selectedModeratorsIdOnGoBack)
        setChipValues(chipValuesOnGoBack)
        setSelectedModerators(selectedModeratorsOnGoBack)
        props.defaultModerators && setDefaultModerators(props.defaultModerators) 
        props.defaultModerators && setDisplayClarificationMessage(true)

    }, [props.moderatorsScheduledInterviews, props.modifiedModerators])

    return (
        <Modal
            title={"ADD/MANAGE MODERATORS"}
            isOpen={props.isOpen}
            className="confirmation-modal add-moderators-modal"
            type="modal"
            autoFocusSubmit={false}
            submitBtnText="Save and Confirm"
            onCancel={props.onCancel}
            onSubmit={() => props.updateProjectModerators({ selectedModerators: selectedModerators.map(mod => { return { ...mod, clientId: props.clientId } }), flag: "multi" , defaultModerators: defaultModerators, defaultModeratorsDetails:defaultModeratorsDetails, clientId: props.clientId})}
            enableSubmit={noModeratorsMsg === '' && !selectionDidNotChange()}
            isSubmitting={props.isSubmitting}
        >
            <div className="add-moderators-modal-body">
                { displayClarificationMessage &&  <div className="calrification-message"> { props.t('calrification-message') } </div>}
                <div className="input-group">
                    <i className="im-search" />
                    <TagInput
                        onInputChange={(value) => { setFilter(value.target.value) }}
                        placeholder="Search for Moderators"
                        values={chipValues}
                        onRemove={onChipRemove}
                        tagProps={getTagProps}
                        addOnBlur={true}
                        addOnPaste={true}
                        disabled={false}
                        fill={false}
                        intent="none"
                        large={false}
                        leftIcon={true}
                        tagIntents={false}
                        tagMinimal={true}
                        inputValue={filter}
                    />
                </div>
                {props.moderatorList.length !== 0 &&
                    <div className="moderators-header">
                        <div className="name-label">Moderator Name & ID Number</div>
                        <div className="interview-count-label">Interviews across all projects</div>
                    </div>
                }
                <div className="moderators-fields">
                    {props.moderatorList.length === 0 && noModeratorsMsg === '' && <Spinner intent="primary" />}
                    {noModeratorsMsg !== '' ?
                        <div className="no-moderators-msg">
                            {noModeratorsMsg}
                        </div> : displayedModerators.map((moderator, i) => <Field
                            type="radio"
                            label={
                                <div className="moderator-radio">
                                    <div className="moderator-info">
                                        <div className="moderator-fullname">{`${moderator.firstName} ${moderator.lastName}`}{moderator.isGlobal ? <span className="global-mod-badge" style={{ marginLeft: 8, fontSize: 10, fontWeight: 700, color: '#5a51a6', background: '#efeafb', borderRadius: 10, padding: '2px 7px', textTransform: 'uppercase' }}>Global</span> : null}</div>
                                        <div className="moderator-id">Moderator #{moderator.id}</div>
                                    </div>
                                    <div className="interviews-info">{moderator.interviewCount} INTERVIEWS</div>
                                </div>
                            }
                            checked={selectedModeratorsId.includes(moderator.id)}
                            onClick={e => handleAddOrRemove(moderator)}
                            key={i}
                        />)}
                </div>
            </div>
        </Modal>
    )
}

export default AddModeratorsModal
